var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WcModal',{on:{"backClick":_vm.backClick}},[_c('div',{staticClass:"wc-modal"},[_vm._t("default"),_c('WcButton',{on:{"btnClick":_vm.confirmClicked}},[_vm._v("確認")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }